import React from 'react';
import { LedgerSelect, LedgerSelectOption } from '../ui';
import { REPORT_STATUS_VALUES, ReportStatusFilter } from '../../hooks/useReportQueries';

const capitalize = (value: string) => value.charAt(0) + value.slice(1).toLowerCase();

const OPTIONS: LedgerSelectOption[] = [
  { value: 'ALL', label: 'All statuses' },
  ...REPORT_STATUS_VALUES.map((value) => ({ value, label: capitalize(value) })),
];

export interface ReportViewsProps {
  status: ReportStatusFilter;
  onStatusChange: (status: ReportStatusFilter) => void;
}

export const ReportViews: React.FC<ReportViewsProps> = ({ status, onStatusChange }) => (
  <LedgerSelect
    value={status}
    options={OPTIONS}
    onValueChange={(value) => onStatusChange(value as ReportStatusFilter)}
    ariaLabel="Report status"
  />
);
